import gql from "graphql-tag";

// eslint-disable-next-line import/prefer-default-export
export const GET_SYNC_STATUS = gql`
  query syncStatus($userId: Int!) {
    syncStatus(userId: $userId) {
      syncInProgress
      statusCode
      statusMessage
    }
  }
`;
